import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";

interface LeaveProjectPopupProps {
  open: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
}

const LeaveProjectPopup = ({
  open,
  handleClose,
  handleSubmit,
}: LeaveProjectPopupProps): JSX.Element => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      data-testid="leaveprojectpopup"
    >
      <DialogTitle>Are you sure you want to leave this project?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: 2 }}>
          After leaving, you will lose access to this project's resources and
          associated tools.
        </DialogContentText>
        <DialogContentText>
          If you need access again in the future, you can only be added back
          to the project by the Product Owner or Scrum Master.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Leave Project
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveProjectPopup;
